module.exports = __webpack_public_path__ + "static/10-4-TECHNOLOGIES-POWERING-THE-FUTURE-OF-WORK-beb6341f1373e64723aec28f27ce52c0.png";